import React from 'react';

const CardImageIcon = ({ note, isLoading, onClick }) => {
  const imageCount = note.inlineImageCount || 0;
  if (!imageCount) return null;

  if (isLoading) {
    return (
      <button className="image-icon-btn" style={{ opacity: 0.5 }} title="Loading images...">
        <i className="fas fa-spinner fa-spin" />
      </button>
    );
  }

  return (
    <div
      className="inline-image-icon"
      style={{ display: 'inline-flex', alignItems: 'center', marginRight: '4px', position: 'relative', cursor: 'pointer' }}
      onClick={(e) => { e.stopPropagation(); onClick(note); }}
      title={`${imageCount} inline image${imageCount !== 1 ? 's' : ''} - Click to view`}
    >
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <i
          className="fas fa-image"
          style={{ fontSize: '18px', color: '#3498db', transition: 'all 0.2s ease' }}
          onMouseEnter={(e) => { e.target.style.transform = 'scale(1.2)'; e.target.style.color = '#2980b9'; }}
          onMouseLeave={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.color = '#3498db'; }}
        />
      </div>
    </div>
  );
};

export default React.memo(CardImageIcon);